// src/redux/slices/modalSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ModalState {
  editCertConnectModal: boolean;
  requestAccessModal: boolean;
  connectionModal: boolean;
  requestSentModal: boolean;
  sortModal: boolean;
  filterModal: boolean;
  certRequestModal:boolean;
   bulkUploadModal: boolean;  
   bulkUploadInfoModal:boolean;
  // add more modals here later
}

const initialState: ModalState = {
  connectionModal: false,
  editCertConnectModal: false,
  requestAccessModal: false,
  requestSentModal: false,
  sortModal: false,
  filterModal: false,
  certRequestModal: false,
  bulkUploadModal: false,
  bulkUploadInfoModal: false,
};

const modalSlice = createSlice({
  name: "modals",
  initialState,
  reducers: {
    toggleModal: (state, action: PayloadAction<keyof ModalState>) => {
      const key = action.payload;
      if (!state[key]) {
        state[key] = true; // only set true
      }
    },
    openModal: (state, action: PayloadAction<keyof ModalState>) => {
      state[action.payload] = true;
    },
    closeModal: (state, action: PayloadAction<keyof ModalState>) => {
      state[action.payload] = false;
    },
  },
});

export const { toggleModal, openModal, closeModal } = modalSlice.actions;
export default modalSlice.reducer;
